import React from 'react';

const Button = (props) => {
  return (
    <button {...props}>
      {props.children}
      <span className="arrow-right">&nbsp;</span>
    </button>
  );
};

export default Button;



// WEBPACK FOOTER //
// ./src/common/components/Button/Button.jsx